export default __webpack_public_path__ + "static/media/spotify.15bf0d27.png";